// extracted by mini-css-extract-plugin
module.exports = {"title":"TransactionDetail_title__3-z1N","card":"TransactionDetail_card___-oRN","container":"TransactionDetail_container__vaFSB"};